import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { mockData } from '../mock';
import { Button } from './ui/button';

const TestimonialSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonials = mockData.testimonials;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 bg-white relative">
      <div className="absolute inset-0 bg-grid-gray-900/[0.02] bg-[size:60px_60px]" />
      <div className="absolute top-10 right-10 w-72 h-72 bg-primary/5 rounded-full blur-3xl" />
      <div className="absolute bottom-10 left-10 w-72 h-72 bg-secondary/5 rounded-full blur-3xl" />
      
      <div className="container mx-auto px-4 relative">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="bg-secondary text-white px-6 py-3 rounded-full text-sm font-bold shadow-lg">
              Client Testimonials
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4">What Our Clients Say</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Trusted by thousands of businesses across the United States
          </p>
        </div>

        <div className="max-w-5xl mx-auto relative px-6 md:px-16">
          <Card className="bg-white shadow-2xl border-2 border-primary/10 hover:border-secondary transition-all duration-500">
            <CardContent className="p-10 md:p-16">
              {/* Quote Icon */}
              <div className="flex justify-center mb-6">
                <div className="bg-secondary/10 w-16 h-16 rounded-full flex items-center justify-center">
                  <svg className="w-8 h-8 text-secondary" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                  </svg>
                </div>
              </div>
              
              <div className="flex justify-center mb-6">
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                  <Star key={i} className="w-7 h-7 fill-secondary text-secondary mx-0.5" />
                ))}
              </div>
              
              <p className="text-2xl text-gray-800 text-center mb-8 leading-relaxed font-medium">
                "{testimonials[currentIndex].text}"
              </p>
              
              <div className="text-center">
                <div className="inline-block">
                  <div className="bg-primary/5 rounded-2xl px-8 py-4">
                    <p className="font-bold text-gray-900 text-xl">{testimonials[currentIndex].name}</p>
                    <p className="text-secondary font-semibold">{testimonials[currentIndex].company}</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Navigation Buttons */}
          <Button
            onClick={goToPrev}
            variant="outline"
            size="icon"
            className="absolute left-0 top-1/2 -translate-y-1/2 rounded-full bg-white shadow-lg hover:bg-secondary/10 z-10"
          >
            <ChevronLeft className="h-6 w-6" />
          </Button>
          
          <Button
            onClick={goToNext}
            variant="outline"
            size="icon"
            className="absolute right-0 top-1/2 -translate-y-1/2 rounded-full bg-white shadow-lg hover:bg-secondary/10 z-10"
          >
            <ChevronRight className="h-6 w-6" />
          </Button>

          {/* Dots */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all ${
                  index === currentIndex ? 'bg-secondary w-8' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSlider;
